import { FETCH_UNITIES_TAGS } from "../actions/types";

const unitiesTags = (state = [], action) => {
  switch (action.type) {
    case FETCH_UNITIES_TAGS:
      return action.payload;
    default:
      return state;
  }
};

export default unitiesTags;
